import {BASE_URL,GET, GET_CUSTOMER_EMAIL} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchCustomerEmail = async (requestId) => {
    const token = await getAccessToken();
    const url = `${BASE_URL}${GET_CUSTOMER_EMAIL}${requestId}`;
    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);
  };